import { render, staticRenderFns } from "./PageCoursesStudentAll.vue?vue&type=template&id=29391652&scoped=true&"
import script from "./PageCoursesStudentAll.vue?vue&type=script&lang=js&"
export * from "./PageCoursesStudentAll.vue?vue&type=script&lang=js&"
import style0 from "./PageCoursesStudentAll.vue?vue&type=style&index=0&id=29391652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29391652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VDivider,VIcon,VImg,VSheet,VSimpleTable})
